import { namedQueryKey, namedQueryKeyWithId } from "../../../../ReactQuery/namedQueryKeyWithId";

export const ttProtectionSelectedFiltersWithIdQueryKey = (
  ttProtectionId: number | string | undefined
) => [...namedQueryKeyWithId("ttProtections", ttProtectionId), "selectedFilters"];

export const ttProtectionOdcsAndCrossDocksQueryKey = [
  ...namedQueryKey("ttProtections"),
  "odcAndCrossDocks",
];

export const ttProtectionIeoPlantsQueryKey = [...namedQueryKey("ttProtections"), "ieoPlants"];

export const ttProtectionPlantForPlantTypesAndAllEdcs = [
  ...namedQueryKey("ttProtections"),
  "plantsForPlantTypesAndAllEdcs",
];
